module.exports = __webpack_public_path__ + "img/icon_bottom_4.c6b7ce70.png";